import { firebase } from "@data/firebase/config";
import { doc, onSnapshot } from "firebase/firestore";

import DatabaseRemoveJobRepository from "@domain/repositories/DatabaseRemoveJobRepository";
import { RemoveJobStore } from "@domain/stores/RemoveJobStore";
import { RemoveJob } from "@domain/models/RemoveJob";

export class FirebaseRemoveJobRepository implements DatabaseRemoveJobRepository {
  COLLECTION = "removeJobs";

  constructor(private readonly removeJobStore: RemoveJobStore) {}

  watchPendingRemoves(jobId: string) {
    const consulta = doc(firebase.db, this.COLLECTION, jobId);
    onSnapshot(
      consulta,
      async (doc) => {
        const data = {
          ...doc.data(),
          id: doc.id,
        } as RemoveJob;

        this.removeJobStore.updateRemoveJob(data);
      },
      (error) => console.log("watchPendingRemoves error", error)
    );
  }
}
